<p-tabs
  class="component-tab"
  (valueChange)="handleTabChange($any($event))"
  [hidden]="!hasTabs()"
  [value]="activeTabIndex">
  <p-tablist>
    @for (tab of tabs; track tab; let i = $index) {
      <p-tab [value]="i">{{ tab.label }}</p-tab>
    }
  </p-tablist>
  <p-tabpanels>
    @for (tab of tabs; track tab; let i = $index) {
      <p-tabpanel [value]="i">
        @for (item of tab.items; track item) {
          @switch (item.layoutType) {
            @case ("TEXT") {
              <p>
                {{ item.label }}
              </p>
            }
            @case ("ACTION") {
              <p>
                <p-button
                  class="pButton ml5"
                  [disabled]="disableAction"
                  (click)="handleActionClick(item)"
                  [label]="item.label"></p-button>
              </p>
            }
          }
        }
      </p-tabpanel>
    }
  </p-tabpanels>
</p-tabs>
